import React, {useState} from "react";
import {FaArrowRight, FaBars, FaTimes} from "react-icons/fa";
import "./header.css";
import logo from "./logo.png";

function Header() {
	const [isOpen, setIsOpen] = useState(false);
	const closeMenu = () => setIsOpen(false);

	return (
		<header className="site-header">
			<div className="site-header__inner">
				<a href="/" className="site-header__brand" onClick={closeMenu} aria-label="Barkr home">
					<span className="site-header__logo-wrap">
						<img src={logo} alt="" className="site-header__logo"/>
					</span>
					<span>Barkr</span>
				</a>

				<nav className={`site-header__nav ${isOpen ? "is-open" : ""}`} aria-label="Main navigation">
					<a href="/#how-it-works" onClick={closeMenu}>How it works</a>
					<a href="/#safety" onClick={closeMenu}>Safety</a>
					<a href="/contact" onClick={closeMenu}>Contact</a>
					<a href="/download" className="site-header__cta" onClick={closeMenu}>
						Get the app <FaArrowRight/>
					</a>
				</nav>

				<button
					type="button"
					className="site-header__menu"
					onClick={() => setIsOpen(!isOpen)}
					aria-expanded={isOpen}
					aria-label={isOpen ? "Close navigation" : "Open navigation"}>
					{isOpen ? <FaTimes/> : <FaBars/>}
				</button>
			</div>
		</header>
	);
}

export default Header;
